/*! V11 Ultra Performance (Home + Product) */
(function(){
  function onReady(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Lazy section rendering: relies on CSS content-visibility for most wins
  onReady(function(){
    if (!('IntersectionObserver' in window)) return;

    var nodes = document.querySelectorAll('[data-v11-section]');
    if (!nodes || !nodes.length) return;

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('v11-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '300px' });

    nodes.forEach(function(el){ io.observe(el); });
  });
})();
